




import Vue from 'vue';
import ImportantInformationReceiveList from '@/components/important-information/important-information-receive-list.component.vue';

export default Vue.extend({
  components: {
    'important-information-receive-list': ImportantInformationReceiveList,
  },
});
